import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap';
import { useToasts } from 'react-toast-notifications';
import '../style.css';
import BranchDropdown from '../components/BranchDropdown';
import {
    CENTERS_ADMIN_ACCESS_MESSAGE,
    getStoredDoctorProfile,
    hasCentersAdminAccess,
} from '../centers/access';

export default function ItemDropDownConfiguration({
    permissionViews,
    dataDoctor,
    branchOfficeOption,
    currentBranchName,
    selectedBranchId,
    onChangeBranch,
    onSignOut,
    onNavigate,
    onSelectItem,
    items,
    defaultItems,
    subtitle = 'Opciones del consultorio',
}) {

    const { addToast } = useToasts();

    // `items` permite a otros layouts (farmacia, call center) definir sus opciones.
    const views = items || defaultItems?.filter(item => permissionViews?.some(item2 => item2?.name === item?.permission));
    const hasBranchOptions = Boolean(branchOfficeOption?.length);
    const validateNavigation = (item, event) => {
        if (item?.permission !== 'centers') {
            if (item.key) {
                onSelectItem?.(item.key, item.value);
                onNavigate?.();
            }
            return;
        }

        const doctorProfile = dataDoctor || getStoredDoctorProfile();

        if (!hasCentersAdminAccess(doctorProfile)) {
            event.preventDefault();
            event.stopPropagation();
            addToast(CENTERS_ADMIN_ACCESS_MESSAGE, {
                appearance: 'error',
                autoDismiss: true,
            });
            return;
        }
    };

    const renderItemContent = (item) => (
        <>
            <span className='doctor-office-popover__item-icon'>
                <i className={item.icon} />
            </span>
            <span className='doctor-office-popover__item-text'>{item.name}</span>
            <i className='fa fa-angle-right doctor-office-config-menu__item-arrow' aria-hidden='true' />
        </>
    );

    const renderConfigItem = (item) => {
        if (!item.nav) {
            return (
                <button
                    key={item.name}
                    type='button'
                    className='doctor-office-config-menu__item doctor-office-popover__item tw-flex tw-w-full tw-items-center tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 tw-transition-colors hover:tw-bg-clinic-surface hover:tw-text-clinic-teal'
                    role="menuitem"
                    aria-label={item.name}
                    onClick={(event) => validateNavigation(item, event)}
                >
                    {renderItemContent(item)}
                </button>
            );
        }

        return (
            <Link
                key={item.name}
                className='doctor-office-config-menu__item doctor-office-popover__item tw-flex tw-items-center tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 tw-no-underline tw-transition-colors hover:tw-bg-clinic-surface hover:tw-text-clinic-teal'
                role="menuitem"
                aria-label={item.name}
                to={item.nav}
                onClick={(event) => {
                    validateNavigation(item, event);
                    if (!event.defaultPrevented) onNavigate?.();
                }}
            >
                {renderItemContent(item)}
            </Link>
        );
    };

    return (
        <div className='animated fadeIn'>
            <div
                className='doctor-office-config-menu tw-absolute tw-right-0 tw-top-[calc(100%+0.4rem)] tw-z-[60] tw-w-64 tw-rounded-md tw-border tw-border-clinic-line tw-bg-white tw-p-2 tw-shadow-clinic'
                id='doctor-office-configuration-panel'
                role='dialog'
                aria-label={`Configuración: ${subtitle}`}
            >
                <div className='doctor-office-popover__header doctor-office-config-menu__header'>
                    <div className='doctor-office-config-menu__header-icon'>
                        <i className='fa fa-cog' aria-hidden='true' />
                    </div>
                    <div>
                        <span>Configuración</span>
                        <small>{subtitle}</small>
                    </div>
                </div>
                {hasBranchOptions && (
                    <div className='doctor-office-config-menu__section'>
                        <span className='doctor-office-config-menu__section-label'>Sucursal activa</span>
                        <BranchDropdown
                            branchOfficeOption={branchOfficeOption}
                            currentBranchName={currentBranchName}
                            selectedBranchId={selectedBranchId}
                            onChangeBranch={(branch) => {
                                onChangeBranch?.(branch);
                                onNavigate?.();
                            }}
                        />
                    </div>
                )}
                <div className='doctor-office-popover__list doctor-office-config-menu__list'>
                    <span className='doctor-office-config-menu__section-label'>Opciones</span>
                    {views?.map(renderConfigItem)}
                </div>
                <div className='doctor-office-config-menu__footer'>
                    <Button
                        type='button'
                        color='danger'
                        className='btn-color-danger'
                        block
                        onClick={(event) => {
                            event.preventDefault();
                            onNavigate?.();
                            onSignOut?.(event);
                        }}
                    >
                        <i className='fa fa-sign-out'></i>
                        {' Cerrar sesión'}
                    </Button>
                </div>
            </div>
        </div>
    )
}
